<ul>
	@for (medicalParameter of medicalParameters; track medicalParameter) {
		<li (click)="selectMedicalData.next(medicalParameter.dataType)">
			<medical-data-item
				[attr.data-test]="medicalParameter.dataType.replace('_', '-') + '-parameter'"
				[icon]="medicalParameter.dataType | medicon"
				[iconColor]="medicalParameter.dataType | mediconColor"
				[title]="medicalParameter.title"
			>
				{{ data | value: medicalParameter.dataType }}
			</medical-data-item>
		</li>
	}
</ul>
